import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { FilterPicker, RadioButtonWithLabel } from 'seagull';
const RadioFilterPicker = (param)=>{
    let { title, testId, defaultLabel, selectedValue, removable, options, onApply, setValue, onRemove, startOpen } = param;
    const [label, setLabel] = useState(defaultLabel);
    return /*#__PURE__*/ _jsx(FilterPicker, {
        testId: testId,
        label: label,
        title: title || label,
        highlightTrigger: false,
        onApply: ()=>onApply(selectedValue),
        onClose: ()=>{},
        onRemove: onRemove,
        removable: removable,
        startOpen: startOpen,
        children: options.map((param)=>{
            let { value, label: optionLabel } = param;
            return /*#__PURE__*/ _jsx(RadioButtonWithLabel, {
                label: optionLabel,
                testId: "".concat(testId, "-option-").concat(value),
                checked: value === selectedValue,
                onChange: ()=>{
                    setValue(value);
                    setLabel(optionLabel);
                }
            }, value);
        })
    });
};
export default RadioFilterPicker;
